import Link from '@jetbrains/ring-ui/components/link/link'
import React, {memo} from 'react'

import {resolveHelpURL} from '../../../../../../utils/url'
import HelpLink from '../../../../../common/HelpLink/HelpLink'
import IconButton from '../../../../../common/IconButton/IconButton'

function SystemDescriptionComponent() {
  return (
    <>
      {'Values that can be passed into build scripts of '}
      <HelpLink
        Component={Link}
        url={resolveHelpURL('using-build-parameters.html#Using+Build+Parameters+in+Build+Scripts')}
        preservePlus
      >
        {'certain runners'}
      </HelpLink>
      {'. Skip the "system." prefix when referencing these values by property names.'}
      <HelpLink
        url={resolveHelpURL('configuring-build-parameters.html#System+Properties')}
        Component={IconButton}
        icon="help"
        preservePlus
      />
    </>
  )
}

export const SystemDescription = memo(SystemDescriptionComponent)
